import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fa600a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "data-cy"]

import ThreeDots from "@/components/svgs/threeDots.vue";
import { ref, onMounted, onBeforeUnmount } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'popoverAssessment',
  props: {
  idPopover: {
    type: String,
    required: true,
  },
  padding: {
    type: String,
    default: "0px",
  },
  styleButton: {
    type: String,
    default: "",
  },
  offset: {
    type: Number,
    default: 25,
  },
  disable: {
    type: Boolean,
    default: false,
  },
  dataCyId: {
    type: String,
    default: "",
  },
  bPopover: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;


const popoverShow = ref(false);
__expose({
  popoverShow,
});

const handleClickOutside = (event: MouseEvent) => {
  const button = document.getElementById(props.idPopover);
  const popover = document.querySelector(".b-popover");

  if (
    button &&
    !button.contains(event.target as Node) &&
    popover &&
    !popover.contains(event.target as Node)
  ) {
    popoverShow.value = false;
  }
};

onMounted(() => {
  EventEmitter.on(EmitterEvents.HIDDEN_SETTINGS, () => {
    popoverShow.value = false;
    // setTimeout(() => {
    //   popoverShow.value = true;
    // }, 10);
  });
  window.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", handleClickOutside);
  EventEmitter.off(EmitterEvents.HIDDEN_SETTINGS);
});

const onclick = () => {
  !props.disable && (popoverShow.value = !popoverShow.value);
};

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock("div", {
      id: __props.idPopover,
      key: __props.idPopover,
      style: _normalizeStyle(`padding: ${__props.padding}`),
      class: _normalizeClass(`three-dots tw-cursor-pointer tw-flex tw-items-center tw-h-full ${__props.styleButton}`),
      "data-cy": __props.dataCyId,
      onClick: onclick
    }, [
      _createVNode(ThreeDots)
    ], 14, _hoisted_1)),
    _createElementVNode("div", null, [
      _createVNode(_component_b_popover, {
        class: _normalizeClass(!popoverShow.value ? 'tw-invisible' : ''),
        target: __props.idPopover,
        triggers: "hover",
        placement: "bottom-end",
        "custom-class": `custom-actions-popover ${__props.bPopover}`,
        offset: __props.offset,
        delay: {
          show: 0,
          hide: 9999999999999,
        }
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header"),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "target", "custom-class", "offset"])
    ])
  ]))
}
}

})